import React from "react";

const Message = props => {
  return <h4 style={{ textAlign: "center" }}>{props.display}</h4>;
};

export default Message;
